export const RODIN_QUALITIES = [ 'high', 'medium', 'low', 'extra-low' ];
export const RODIN_TIERS = [ 'Sketch', 'Regular', 'Detail', 'Smooth' ];
export const RODIN_MATERIALS = [ 'PBR', 'Shaded', 'All', 'None' ];
export const RODIN_MESH_MODES = [ 'Quad', 'Raw' ];
export const RODIN_CONDITION_MODES = [ 'concat', 'fuse' ];
export const RODIN_QUALITY_OVERRIDE_MIN = 2000;
export const RODIN_QUALITY_OVERRIDE_MAX = 200000;
export const RODIN_SEED_MIN = 0;
export const RODIN_SEED_MAX = 65535;

export const RODIN_DEFAULTS = {
  quality: 'medium',
  qualityOverride: '',
  tier: 'Regular',
  material: 'PBR',
  meshMode: 'Quad',
  meshSimplify: true,
  meshSmooth: false,
  conditionMode: 'concat',
  seed: '',
  prompt: '',
};

const isSet = value => value !== '' && value !== null && value !== undefined;

export const buildRodinProperties = settings => {
  const {
    quality,
    qualityOverride,
    tier,
    material,
    meshMode,
    meshSimplify,
    meshSmooth,
    conditionMode,
    seed,
    prompt,
  } = settings;

  const properties = {
    quality,
    tier,
    material,
    meshMode,
    meshSimplify,
    meshSmooth,
    conditionMode,
  };

  if (isSet(qualityOverride)) {
    properties.qualityOverride = Number(qualityOverride);
  }
  if (isSet(seed)) {
    properties.seed = Number(seed);
  }
  if (prompt) {
    properties.prompt = prompt;
  }

  return properties;
};

export const validateRodinSettings = settings => {
  const errors = {};
  const { quality, qualityOverride, tier, material, meshMode, conditionMode, seed } = settings;

  if (!RODIN_QUALITIES.includes(quality)) {
    errors.quality = 'Invalid quality.';
  }
  if (!RODIN_TIERS.includes(tier)) {
    errors.tier = 'Invalid tier.';
  }
  if (!RODIN_MATERIALS.includes(material)) {
    errors.material = 'Invalid material.';
  }
  if (!RODIN_MESH_MODES.includes(meshMode)) {
    errors.meshMode = 'Invalid mesh mode.';
  }
  if (!RODIN_CONDITION_MODES.includes(conditionMode)) {
    errors.conditionMode = 'Invalid condition mode.';
  }

  if (isSet(qualityOverride)) {
    const numericOverride = Number(qualityOverride);
    if (!Number.isFinite(numericOverride)
      || numericOverride < RODIN_QUALITY_OVERRIDE_MIN
      || numericOverride > RODIN_QUALITY_OVERRIDE_MAX) {
      errors.qualityOverride =
        `Quality override must be between ${RODIN_QUALITY_OVERRIDE_MIN} and ${RODIN_QUALITY_OVERRIDE_MAX}.`;
    }
  }

  if (isSet(seed)) {
    const numericSeed = Number(seed);
    if (!Number.isInteger(numericSeed) || numericSeed < RODIN_SEED_MIN || numericSeed > RODIN_SEED_MAX) {
      errors.seed = `Seed must be an integer between ${RODIN_SEED_MIN} and ${RODIN_SEED_MAX}.`;
    }
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
